import angular from 'angular';
import taskContent from './taskContent';

export default angular
  .module('components.taskContent', [])
  .component('taskContent', taskContent).name;
